import { render, staticRenderFns } from "./contactEditDialog.vue?vue&type=template&id=4d4dc4de&"
import script from "./contactEditDialog.vue?vue&type=script&lang=js&"
export * from "./contactEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports